import { createFileRoute, notFound } from "@tanstack/react-router";

import { ScoreBoard } from "@/components/matches/score-board";
import { DefaultLayout } from "@/layouts/default";
import { playerNames } from "@/utils/profiles";
import { isNotNull } from "@/utils/types";

export const Route = createFileRoute("/matches/pool/$matchId/")({
  ssr: "data-only",
  loader: async ({ params: { matchId }, context: { queryClient, trpc } }) => {
    const match = await queryClient.ensureQueryData(
      trpc.matches.get.queryOptions({
        poolMatchId: Number.parseInt(matchId, 10),
      }),
    );

    if (!match) {
      throw notFound();
    }

    return match;
  },
  head: ({ loaderData }) => ({
    meta: loaderData
      ? [
          {
            title: `Match ${loaderData.matchNumber}: ${[
              loaderData.teamA,
              loaderData.teamB,
            ]
              .filter(isNotNull)
              .map(({ team }) =>
                playerNames(team.players.map(({ profile }) => profile)).join(
                  " & ",
                ),
              )
              .join(" vs ")}`,
          },
        ]
      : undefined,
  }),
  component: RouteComponent,
});

// TODOs:
//
// - Start match
// - Undo complete match (subtrack 1 from winning score and change status)
// - N to switch
// - Side switch modal
// - Serve order tracker
//
// - Referees for permission

function RouteComponent() {
  const { matchId: matchIdStr } = Route.useParams();

  const poolMatchId = Number.parseInt(matchIdStr, 10);

  return (
    <DefaultLayout>
      <ScoreBoard poolMatchId={poolMatchId} />
    </DefaultLayout>
  );
}
